export { type PromotionProps, default as Promotion } from './Promotion';
